import tippy from 'tippy.js'
import 'tippy.js/dist/tippy.css'

export default {
  mounted(el, binding, vnode) {
    vnode.tippy = tippy(el, {
      theme: 'light',
      maxWidth: 200,
      content: binding.value,
      trigger: 'mouseenter',
      allowHTML: true
    })
  },
  updated(_, binding, vnode, oldVnode) {
    vnode.tippy = oldVnode.tippy
    vnode.tippy.setContent(binding.value)
  },
  unmounted(_, __, vnode) {
    vnode.tippy.destroy()
  }
}
